// API configuration for SSA Techno frontend.
//
// v1 backend (projects, abouts, services, blogs, careers, banners, etc.):
//   REACT_APP_API_BASE_URL → defaults to https://ssatech-backend.pixoatic.in/api/v1

export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "https://backendssa.ssatechno.in/api/v1";
